export const personType = Object.freeze({
  USER: "user",
  HOUSEHOLD_MEMBER: "householdMember",
  ADDITIONAL_NAME: "additionalName",
  HOUSEHOLD: "household",
});
